export const MagnifyingGlassIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 7.5C13.5 10.8135 10.8135 13.5 7.5 13.5C4.1865 13.5 1.5 10.8135 1.5 7.5C1.5 4.1865 4.1865 1.5 7.5 1.5C10.8135 1.5 13.5 4.1865 13.5 7.5Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.5 16.5L12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
